import { render } from "./CustomData.vue?vue&type=template&id=5b84d318&scoped=true"
import script from "./CustomData.vue?vue&type=script&lang=js"
export * from "./CustomData.vue?vue&type=script&lang=js"

import "./CustomData.vue?vue&type=style&index=0&id=5b84d318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b84d318"]])

export default __exports__